import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=fe734420&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=fe734420&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe734420",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe734420')) {
      api.createRecord('fe734420', component.options)
    } else {
      api.reload('fe734420', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=fe734420&scoped=true", function () {
      api.rerender('fe734420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/footer/type_6/Footer.vue"
export default component.exports